<!-- 電話番号入力コンポーネント -->
<template>
    <dd :class="validate.$error | klass">
        <template v-if="validate.$error">
            <span v-if="!validate.required"
                  class="errNote">電話番号を入力してください。</span>
        </template>
        <template v-if="validate.$invalid">
            <span v-if="!validate.phoneNumberRule"
                  class="errNote">電話番号はハイフンなしで半角数字のみを入力してください。</span>
        </template>
        <input v-model="validate.$model"
               @input="setUserInfoPatch"
               name="tel_no_fixed"
               type="text"
               class="regular"
               placeholder="09000000000">
    </dd>
</template>

<script>
import { mixinUserInfoFieldComponent } from '../../mixin/utility'

export default {
    name: "UserInfoPhoneNumberField",
    mixins: [mixinUserInfoFieldComponent],
    props: {
        validate: {
            type: Object,
            required: true
        }
    },
    methods: {
        setUserInfoPatch: function(ev){
            const value = ev.target.value;
            this.$emit('set-user-info-patch', 'tel_no_fixed', value);
        }
    }
}
</script>
